"use strict";
/**
 * @file 配置文件
 * @author Auto Generated by CommonFile
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASS_NAME_PREFIX = void 0;
/**
 * 样式类名前缀
 */
exports.CLASS_NAME_PREFIX = 'polyv';
